import Vue from 'vue'
import Router from 'vue-router'

import { SegmentsHome, SegmentsCreate, SegmentsUpdate, SegmentsClone, SegmentsImport } from './views/segments'
import { ConfigurationsHome, ConfigurationsUpdate } from './views/configurations'

Vue.use(Router)

const routes = [
  {
    name: 'Home',
    path: '/',
    component: SegmentsHome
  },
  {
    name: 'ConfigurationsHome',
    path: '/configurations',
    component: ConfigurationsHome
  },
  {
    name: 'ConfigurationsUpdate',
    path: '/configurations/:id',
    component: ConfigurationsUpdate
  },
  {
    name: 'Create',
    path: '/create',
    component: SegmentsCreate
  },
  {
    name: 'Import',
    path: '/import',
    component: SegmentsImport
  },
  {
    name: 'Update',
    path: '/:id',
    component: SegmentsUpdate
  },
  {
    name: 'Clone',
    path: '/clone/:id',
    component: SegmentsClone
  }
]

const router = new Router({ mode: 'history', routes })

export default router
